import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { OverlayPanel } from "primereact/overlaypanel";
import { useEffect, useRef, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";

import Providencias from "./providencias";

import {
  buscarTiposRestricoes,
  excluir,
  initFormRestricao,
  salvar,
} from "../../../service/Monitora/Lancamentos/restricoes";

import {
  detailAlteracaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  detailExclusaoSucessoPadrao,
  printToast,
  summaryAlteracaoSucessoPadrao,
  summaryCriacaoSucessoPadrao,
  summaryExclusaoSucessoPadrao,
} from "../../../config/global";

const Restricoes = ({ ptaMonitora, setVisible, setFormPta, isPodeEditar }) => {
  const [formR, setFormR] = useState(initFormRestricao);
  const [restricao, setRestricao] = useState(null);
  const [tiposrestricoes, setTiposrestricoes] = useState([]);
  const [qtdMaxCaracteres, setQtdMaxCaracteres] = useState(2000);
  const [countCaracteres, setCountCaracteres] = useState(0);
  const [restricoes, setRestricoes] = useState(ptaMonitora.restricoes);
  const opProvidencias = useRef(null);
  const [providencias, setProvidencias] = useState(null);

  useEffect(() => {
    buscarTiposRestricoes().then((res) => {
      setTiposrestricoes(res);
    });
    contarCaracteres();
    opProvidencias.current.hide();
  }, [restricoes]);

  const OpcoesRestricoes = [
    {
      name: "NÃO",
      code: "N",
    },
    {
      name: "SIM",
      code: "S",
    },
    {
      name: "PARCIALMENTE",
      code: "P",
    },
  ];
  const isValidDate = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  };

  const validateFields = () => {
    const { dataRestricao, tipoRestricao, descRestricao, dataSuperacao, flagSuperacao, statRestricao } = formR;

    if (!dataRestricao || !isValidDate(dataRestricao)) {
      return "Data de Restrição inválida ou não preenchida.";
    }
    if (dataSuperacao && !isValidDate(dataSuperacao)) {
      return "Data de Superação inválida.";
    }
    if (!descRestricao) {
      return "Descrição da Restrição não preenchida.";
    }
    if (flagSuperacao === null) {
      return "A restrição foi solucionada não preenchida.";
    }
    if (!tipoRestricao) {
      return "Tipo de Restrição não preenchido.";
    }

    return null; // Indica que não houve erro
  };

  const salvarRestricao = () => {
    const errorMessage = validateFields();

    if (errorMessage) {
      printToast({ severity: "error", detail: errorMessage });
      return;
    }

    formR.ptaMonitora = ptaMonitora;
    let jsonPost = { ...formR };
    let summary = formR.idenRestricao > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
    let detail = formR.idenRestricao > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

    salvar(jsonPost).then((res) => {
      let restricao = restricoes.filter((item) => item.idenRestricao != res.idenRestricao);
      setRestricoes([...restricao, { ...res, providencias: [] }]);
      setFormR(initFormRestricao);
      setFormPta({ ...ptaMonitora, restricoes: [...restricao, { ...res, providencias: [] }] });
      printToast({ summary, detail });
    });
  };

  function editarRestricao(rowData) {
    setFormR({
      ...rowData,
      statRestricao: OpcoesRestricoes.find((opcao) => opcao.name == rowData.statRestricao.toUpperCase()).code, //conversao do tipo para fazer a edicao
    });
  }
  function excluirRestricao(rowData) {
    excluir(rowData.idenRestricao).then((res) => {
      let restricoesExc = restricoes.filter((item) => item.idenRestricao != rowData.idenRestricao);
      setRestricoes(restricoesExc);
      setFormPta({ ...ptaMonitora, restricoes: restricoesExc });
      printToast({ summaryExclusaoSucessoPadrao, detailExclusaoSucessoPadrao });
    });
  }

  const rejectFunc = () => {};

  const confirmaExclusao = (rowData, countProvidencias) => {
    if (countProvidencias == 0) {
      confirmDialog({
        message: "Deseja excluir esta restrição?",
        header: "Confirmação",
        icon: "pi pi-exclamation-triangle",
        accept: () => excluirRestricao(rowData),
        reject: () => rejectFunc(),
      });
    } else {
      confirmDialog({
        message: (
          <div>
            Esta ‘restrição’ possui pelo menos uma ‘providência’. <br /> Por favor, exclua primeiro as respectivas
            ‘providências’ para proceder com a exclusão da ‘restrição
          </div>
        ),
        header: "Informação",
        icon: "pi pi-exclamation-triangle",
        rejectClassName: "hidebottom", //codigo alternativo para esconder o botao
        acceptClassName: "hidebottom", //codigo alternativo para esconder o botao
      });
    }
  };
  const acoesTemplate = (node, column) => {
    let v_providencias =
      node.providencias != null ? node.providencias.filter((item) => item.statProvidencia === 1) : null;
    let countProvidencias = !v_providencias || !v_providencias.length ? "0" : v_providencias.length;
    return (
      <>
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-warning Raised"
          onClick={() => editarRestricao(node)}
          disabled={!isPodeEditar || !ptaMonitora.permiteAndamento}
        ></Button>
        <Button
          type="button"
          icon="pi pi-trash"
          style={{ marginLeft: "5px" }}
          className="p-button-danger Raised"
          onClick={() => confirmaExclusao(node, countProvidencias)}
          disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
        ></Button>
      </>
    );
  };
  //Tratamento para colocar a coluna das Providencias separado
  const acoesTemplateProv = (node, column) => {
    let v_providenciasProv =
      node.providencias != null ? node.providencias.filter((item) => item.statProvidencia === 1) : null;
    let countProvidenciasProv = !v_providenciasProv || !v_providenciasProv.length ? "0" : v_providenciasProv.length;

    return (
      <>
        <i
          title="Providências"
          className="pi pi-comments mr-4 p-text-secondary p-overlay-badge"
          style={{ fontSize: "2rem", marginLeft: "3px" }}
          onClick={(e) => abrirProvidencias(e, node)}
        >
          <Badge value={countProvidenciasProv}></Badge>
        </i>
      </>
    );
  };

  function contarCaracteres() {
    setCountCaracteres(formR.descRestricao != null ? qtdMaxCaracteres - formR.descRestricao.length : 2000);
  }
  function abrirProvidencias(event, dados) {
    setRestricao(dados);
    setProvidencias(dados.providencias.filter((item) => item.statProvidencia === 1));
    opProvidencias.current.toggle(event);
  }
  const flagSuperacaoTemplate = (rowData) => {
    if (rowData.flagSuperacao === "S") return "Sim";
    if (rowData.flagSuperacao === "N") return "Não";
    if (rowData.flagSuperacao === "P") return "Parcial";
    if (rowData.flagSuperacao === 0) return "Sim";
    if (rowData.flagSuperacao === 1) return "Não";
    if (rowData.flagSuperacao === 2) return "Parcial";

    return "";
  };
  return (
    <>
      <CardSeplag title="Restrições">
        <div className="p-fluid grid">
          <div className="field col-12 md:col-2 ">
            <span>
              <label htmlFor="datarestricao">Data</label>
              <InputMask
                mask="99/99/9999"
                slotChar="__/__/____"
                placeholder="__/__/____"
                id="datarestricao"
                value={formR.dataRestricao}
                onChange={(e) => setFormR({ ...formR, dataRestricao: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>
          <div className="field col-12 md:col-4 ">
            <span>
              <label htmlFor="tiposrestricoes">Tipo de Restrição</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                options={tiposrestricoes}
                value={formR.tipoRestricao}
                optionLabel="nomeTipoRestricao"
                filter
                showClear
                filterBy="descUnidadeExecucao"
                placeholder="Selecione um tipo de restrição"
                onChange={(e) => setFormR({ ...formR, tipoRestricao: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>

          <div className="field col-12 md:col-4 ">
            <span>
              <label htmlFor="tiporestricoes">A restrição foi solucionada?</label>
              <Dropdown
                id="tiporestricoes"
                emptyMessage="Dados não encontrados"
                value={formR.flagSuperacao}
                options={OpcoesRestricoes}
                optionValue="code"
                optionLabel="name"
                filter
                showClear
                filterBy="name"
                placeholder="Selecione um tipo de solução"
                onChange={(e) => setFormR({ ...formR, flagSuperacao: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>

          <div className="field col-12 md:col-2 ">
            <span>
              <label htmlFor="datasuperacao">Data Solução</label>
              <InputMask
                mask="99/99/9999"
                slotChar="__/__/____"
                placeholder="__/__/____"
                id="datasuperacao"
                value={formR.dataSuperacao}
                onChange={(e) => setFormR({ ...formR, dataSuperacao: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>
          <div className="field col-12 md:col-12 ">
            <span>
              <label htmlFor="descrestricao">Descrição</label>
              <InputTextarea
                id="descrestricao"
                maxLength={2000}
                rows={5}
                cols={30}
                value={formR.descRestricao}
                onKeyUp={(e) => setCountCaracteres(qtdMaxCaracteres - e.target.value.length)}
                onChange={(e) => setFormR({ ...formR, descRestricao: e.target.value })}
                disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
              />
            </span>
          </div>
          <div className="field col-12 md:col-12 ">
            <span>
              <b>{countCaracteres}</b> caractere(s) restante(s)
            </span>
          </div>
        </div>
      </CardSeplag>
      <div className="p-fluid grid">
        <div className="field col-12 md:col-9 ">&nbsp;</div>
        <div className="field col-12 md:col-3 ">
          <br></br>
          <Button
            label="Salvar"
            icon={"pi pi-check"}
            autoFocus
            disabled={!isPodeEditar || !ptaMonitora.permiteRestricaoProvidencia}
            className="p-button-success"
            onClick={salvarRestricao}
          />
        </div>
      </div>
      <ConfirmDialog />
      <Dialog />
      <CardSeplag title="Restrições cadastradas">
        <DataTable
          emptyMessage="Não foram encontradas restrições para este item"
          value={restricoes}
          sortField="idenRestricao"
          sortOrder={1}
        >
          <Column
            body={acoesTemplate}
            style={{ textAlign: "center", width: "18%" }}
            field="idenRestricao"
            header="Ações"
          ></Column>
          <Column field="idenRestricao" header="Id" style={{ display: "none" }}></Column>
          <Column field="dataRestricao" header="Data"></Column>
          <Column field="tipoRestricao.nomeTipoRestricao" header="Tipo de Restrição"></Column>
          <Column field="descRestricao" header="Descrição da Restrição"></Column>
          <Column body={flagSuperacaoTemplate} header="Solucionada?"></Column>
          <Column body={acoesTemplateProv} header="Providências"></Column>
        </DataTable>
      </CardSeplag>

      <OverlayPanel
        ref={opProvidencias}
        id="overlay_panel"
        style={{ width: "950px", height: "600px", overflowY: "scroll", overflowX: "hidden" }}
        className="overlaypanel-demo"
      >
        <Providencias
          restricao={restricao}
          restricoes={restricoes}
          setRestricoes={setRestricoes}
          providencias={providencias}
          setProvidencias={setProvidencias}
          opProvidencias={opProvidencias}
          setFormPta={setFormPta}
          ptaMonitora={ptaMonitora}
          isPodeEditar={isPodeEditar}
        ></Providencias>
      </OverlayPanel>
    </>
  );
};

export default Restricoes;
